import {
  SubmissionForm,
  TextInputField,
  ToggleField,
  IStackProps,
  Stack,
  useTheme
} from "@bps/fluent-ui";
import { DeploymentRing } from "@libs/api/gateways/field/field-ops-gateway.dtos";

export interface RingFormValues {
  displayName: string;
  code: string;
  isPublic: boolean;
  description: string;
}

interface RingFormProps extends Omit<IStackProps, "onSubmit"> {
  ring?: DeploymentRing;
  onSubmit: (values: RingFormValues) => Promise<void>;
}

export const RingForm: React.FC<RingFormProps> = ({ ring, onSubmit }) => {
  const theme = useTheme();

  return (
    <SubmissionForm<RingFormValues>
      initialValues={ring}
      onSubmit={onSubmit}
      hideCancelButton
    >
      {() => (
        <Stack tokens={{ childrenGap: theme.spacing.s1 }}>
          <TextInputField label="Display Name" required name="displayName" />
          <TextInputField label="Code" required name="code" />
          <ToggleField label="Public Opt-In" name="isPublic" />
          <TextInputField
            label="Description"
            required
            multiline
            name="description"
          />
        </Stack>
      )}
    </SubmissionForm>
  );
};
